import './webfontloader'
import { registerBaseComponents } from './base'
import { registerApexCharts } from './apexChart'

const registerPlugins = (app) => {
  registerBaseComponents(app)
  registerApexCharts(app)
}

export default registerPlugins
